import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import {
    Button
} from "@mui/material";
import { useContext } from "react";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AppContext } from "src/contexts/AppContextProvider";

function StartButton() {
	const { t } = useTranslation();
	const ctx = useContext(AppContext);
	const navigate = useNavigate();

	const onLoginClick = () => {
		isMobile ? navigate("/scan") : navigate("/dashboard");
	}
	return <>
		{ctx.isLoggedIn ?
			<Button
				startIcon={<HomeRoundedIcon />}
				variant="contained"
				component="span"
				size="large"
				onClick={onLoginClick}
				className="start-button">
				{t("Login")}
			</Button>
			:
			<Button
				endIcon={<ArrowForwardIcon />}
				variant="contained"
				component="span"
				size="large"
				onClick={() => navigate("/onboard")}
				className="start-button">
				{t("StartForFree")}
			</Button>
		}
	</>;
}

export default StartButton;
